import { PlayerState, PlayerAction } from './types'

export const initialState: PlayerState = {
  player: null,
  highlights: [],
  loading: true,
  error: null,
}

export function playerReducer(
  state: PlayerState,
  action: PlayerAction
): PlayerState {
  switch (action.type) {
    case 'SET_LOADING':
      return { ...state, loading: action.payload }
    case 'SET_PLAYER':
      return { ...state, player: action.payload, loading: false, error: null }
    case 'SET_HIGHLIGHTS':
      return { ...state, highlights: action.payload }
    case 'SET_ERROR':
      return { ...state, error: action.payload, loading: false }
    default:
      return state
  }
}
